import { CrudChartRenderData } from "@/modules/Dashboards/AdminDashboard/models/CrudChartRenderData";
import { OPERATORS_FILTERS } from "@/shared/constants/GeneralConstants";
import { SecondaryFilter } from "../../Dashboards/AdminDashboard/models/SecondaryFilter";

export const SESSION_TEMP_CONSTANTS = {
  PAGE_TITLE_SEARCH: "Consulta de sesiones",
  PAGE_TITLE_CREATE: "Agregar sesión",
  PAGE_TITLE_EDIT: "Editar sesión",
  LABEL: {
    NAME: "Nombre sesión*",
    URL_PLAYBOOK: "URL playbook*"
  },
  BUTTON: {
    ADD_SESSION_TEMP: "Crear sesión",
    CANCEL: "Cancelar"
  },
  DELETE_MODAL: {
    TITLE: "Eliminar sesión",
    TEXT: "Ingrese la razón por la cual va a deshabilitar la sesión:"
  },
  MESSAGE: {
    MAX_LENGTH: "Máximo 50 caracteres",
    NAME_EXISTS: "El nombre de la sesión ya existe",
    NOT_FOUND_TEMPLATES: "No se encontraron plantillas de sesiones"
  },
  ACTIONS: {
    EDIT: "edit",
    CREATE: "create",
    CANCEL: "cancelar"
  }
};

export const CHART_INIT: CrudChartRenderData = {
  chartTitle: "",
  chartRenderData: {
    labels: [],
    datasets: [
      {
        data: []
      }
    ]
  }
};

export const SAVE_SESSION_TEMPLATE_ID = "saveSessionTemplate";

export const VISUAL_NAME = "visualName";

export const CATEGORIES = "categories";

export const VOIDED_FALSE = "false";

export const SESSION_TEMPLATE_FORM = "sessionTemplateForm";

export const SAVE = "save";

export const CANCEL = "cancel";

export const CLOSE_FORM = "closeForm";

export const CHART_TITLE = "Sesiones por categoria";

export const SESSIONS_FILTERS = {
  MAIN: {
    mainFilterKey: "sesion",
    mainFilterName: "Todos",
    avatar: "mdi-animation",
    secondaryFilters: [] as SecondaryFilter[],
    initial: true,
    placeholder:
      "Escriba el nombre de la sesión o utiliza los filtros para agrupar información"
  },
  SECONDARY: {
    NAME: {
      name: "Nombre",
      placeholder: "Nombre de Sesion",
      key: "name",
      avatar: "mdi-form-textbox",
      type: "secondaryFilter",
      default: true,
      disabled: false,
      operators: OPERATORS_FILTERS,
      display: "unique"
    },
    CATEGORY: {
      name: "Categoria",
      placeholder: "Categoria de Sesion",
      key: "category",
      avatar: "mdi-checkbox-multiple-blank",
      type: "secondaryFilter",
      default: true,
      disabled: false,
      operators: OPERATORS_FILTERS,
      display: "list",
      options: []
    },
    STATUS: {
      name: "Estado",
      placeholder: "Estado de Sesion",
      key: "state",
      avatar: "mdi-list-status",
      type: "secondaryFilter",
      disabled: false,
      operators: OPERATORS_FILTERS,
      display: "list",
      options: [
        { name: "Activo", key: "Activo" },
        { name: "Inactivo", key: "Inactivo" }
      ]
    }
  }
};

export const CATEGORY_LIST = "7xTl5lFhfLlY3NaAW0fI";
export const LIST_LOADING = "Cargando lista...";
export const SESSION_FORM = {
  SELECT_CATEGORY: "Seleccione categoria",
  CATEGORY: "Categoria*"
};

export const SESSION_VALIDATORS = {
  MAX_LENGTH: (v: string) =>
    v.length <= 50 || SESSION_TEMP_CONSTANTS.MESSAGE.MAX_LENGTH
};

export const SESSION_TEMPLATES_ACCESS = {
  GET: "consultar plantillas de sesiones",
  POST: "crear plantillas de sesiones",
  PUT: "modificar plantillas de sesiones",
  DELETE: "eliminar plantillas de sesiones"
};
